import React, { useState } from "react"
import Layout from "@layouts/Layout"
import { Container, Button, Table } from "react-bootstrap"
import CheckoutModal from "@components/CheckoutModal"
import SEO from "../components/SEO"
import { useStore } from "../components/StoreContext"

const Checkout = () => {
  const [modalShow, setModalShow] = useState(false)
  const { state, dispatch } = useStore()

  const removeItem = (id, price) => {
    dispatch({ type: "removeItem", payload: { id, price } })
  }

  return (
    <Layout>
      <SEO title="Checkout" />
      <Container className="py-6 py-md-8">
        <h2>
          1. <u>View your products</u>
        </h2>
        <ul className="mb-5 font-weight-light">
          <li>
            If you are happy with your cart please{" "}
            <span className="font-weight-normal text-powder">
              move to checkout
            </span>{" "}
            where you will be asked for you contact details.
          </li>
          <li>
            After this you will be put through to{" "}
            <span className="font-weight-normal text-powder">PayFast</span>{" "}
            where you can choose a payment method.
          </li>
        </ul>

        <Table striped bordered>
          <thead>
            <tr>
              <th>Product</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {state?.items.length > 0 ? (
              state.items.map(({ title, price, id }, index) => {
                return (
                  <tr key={index}>
                    <td>{title}</td>
                    <td>R{price}</td>
                    <td>
                      <Button
                        variant="outline-danger"
                        onClick={() => removeItem(id, price)}
                        size="sm"
                      >
                        Remove
                      </Button>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="3">no items</td>
              </tr>
            )}
            <tr>
              <td colSpan="3" className="text-powder">
                Total : R{state?.total ?? 0}
              </td>
            </tr>
          </tbody>
        </Table>

        <Button
          variant="powder"
          onClick={() => setModalShow(true)}
          className="mt-3"
          disabled={state?.items.length === 0 ?? false}
        >
          Move to checkout ->
        </Button>

        <CheckoutModal show={modalShow} hide={() => setModalShow(false)} />
      </Container>
    </Layout>
  )
}

export default Checkout
